<wm-data-entity-view
  *ngIf="this.entity.dataEntityRef && showEntity"
  [entity]="this.entity.dataEntityRef"
  [showLabel]="showLabel"
></wm-data-entity-view>
